import "regenerator-runtime/runtime";
import axios from "axios";
let mainvar = bsstracking;

let apiclient = null;
let wpclient = null;

/**
 * Ritorna un'istanza di axios che ad ogni richiesta in automatico: 
 * 
 *  -utilizza l'url ricevuto come formparam 'action'
 * 
 *  -come url l'url di base (admin-ajax.php)
 * 
 *  -aggiunge ai formparam il nonce
 * 
 * @returns {import("axios").AxiosInstance}
 */
const buildwpclient = () => {
    wpclient = axios.create({
        withCredentials: false,
        baseURL: mainvar.ajaxurl, 
        timeout: 10000,
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });

    wpclient.interceptors.request.use(async (cfg) => {

        if(mainvar.nou(cfg.data)){
            cfg.data = {};
        }

        cfg.data.nonce = mainvar.nonce;
        cfg.data.action = cfg.url;
        cfg.url = cfg.baseURL
        cfg.data = new URLSearchParams(cfg.data).toString();
        return cfg;
    });

    return wpclient;
}

/**
 * Ritorna un'istanza di axios che ad ogni richiesta in automatico: 
 * 
 *  -utilizza come baseurl quello definito in env.php, base url viene ignorato se viene passato un url assoluto
 * 
 *  -aggiunge il token di keycloak negli header (solo se presente)
 * 
 * @returns {import("axios").AxiosInstance}
 */
const buildapiclient = () => {
    apiclient = axios.create({
        withCredentials: false,
        baseURL: mainvar.ws.baseurl, 
        timeout: 10000,
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
    
    apiclient.interceptors.request.use(async (cfg) => {
        let token = mainvar.recursiveGetter(mainvar, "keycloak.token", null);
        
        if(cfg.headers["Content-Type"] === "application/x-www-form-urlencoded") {
            cfg.data = new URLSearchParams(cfg.data).toString();
        }
        
        if (token !== null) { 
    
            try {
                const refreshed = await mainvar.aggiornatoken();
                token = mainvar.recursiveGetter(mainvar, "keycloak.token", null);
                console.log("token aggiornato?", refreshed, )
            } catch(err){
                console.log("non è stato possibile aggiornare il token!", err);
            }
            
            cfg.headers["authorization"] = "Bearer " + token;
                    
        }
    
        return cfg;
    });

    return apiclient;
}

const getapiclient = () => {
    if([null, undefined].includes(apiclient)){
        
        apiclient = buildapiclient();

    }

    return apiclient;
}

const getwpclient = () => {
    if([null, undefined].includes(wpclient)){
        
        wpclient = buildwpclient();

    }

    return wpclient;
}

export default getapiclient;
export {getwpclient}
